import styled from 'styled-components';
import SelectSearch from './SelectSearch';
import sharedStyles from '../styles';
import breakpoints from '../breakpoints';

const FilterBox = styled(SelectSearch)`
  display: ${({ active }) => (active ? 'block' : 'none')};
  padding: 0 ${sharedStyles.spacing['spacing-lg']} 0
    ${sharedStyles.spacing['spacing-md']};

  @media screen and (min-width: ${breakpoints.md}) {
    display: none;
  }
`;

export default FilterBox;
